/**
 * Returns a controlled input's live display value without normalizing user input.
 * Defaults are only for settings that have never been supplied; save-time/server
 * normalization remains responsible for trimming persisted values.
 */
export const getPromoStoreSettingInputValue = (value, fallback) => (
  value === null || value === undefined ? fallback : String(value)
);
